import Consumption from '../../../../base/forms/airdome/consumption';

const consumption: Consumption = {
  start: 'Začátek',
  end: 'Konec'
};

export default consumption;
